import { useField } from 'formik';
import { ticketFieldLabelClass } from '../core/_utils';
import TicketFieldHint from './TicketFieldHint';

type Props = {
  name: string;
  label: string;
  placeholder: string;
  inputMode: 'decimal' | 'numeric';
  required?: boolean;
  help?: string;
  prefix?: string;
  suffix?: string;
};

const TicketAddonField = ({ name, label, placeholder, inputMode, required = false, help, prefix, suffix }: Props) => {
  const [field, meta] = useField(name);
  const labelClass = ticketFieldLabelClass(required);
  const id = `ticket-${name}`;
  const error = meta.touched ? meta.error : undefined;

  return (
    <div className="mb-5">
      <label className={labelClass} htmlFor={id}>
        {label}
      </label>
      <div className="input-group input-group-solid">
        {prefix ? <span className="input-group-text">{prefix}</span> : null}
        <input className="form-control" id={id} inputMode={inputMode} placeholder={placeholder} {...field} />
        {suffix ? <span className="input-group-text">{suffix}</span> : null}
      </div>
      <TicketFieldHint error={error} help={help} />
    </div>
  );
};

export default TicketAddonField;
